<style lang="scss" scoped>
  @import "@/assets/scss/vuexy/pages/HeaderIndex.scss";
</style>
<template>
  <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between mb-4">
    <div class="container-icons-header">
      <feather-icon v-for="(btn, index) in buttons"  v-bind:key="index"
      :icon="btn.icon"
      @click="update(btn.emitName)"
      class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer sm:inline-flex"
      :svgClasses="{'text-primary stroke-current': currentView === btn.emitName }"/>
      <feather-icon
      icon="GridIcon"
      @click="update('grid')"
      class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
      :svgClasses="{'text-primary stroke-current': currentView === 'grid'}" />
      <feather-icon
      icon="ListIcon"
      @click="update('list')"
      class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer sm:inline-flex"
      :svgClasses="{'text-primary stroke-current': currentView === 'list'}" />
      <feather-icon
      icon="MapIcon"
      @click="update('map')" v-if="path !== '/labels'"
      class="p-2 ml-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer sm:inline-flex"
      :svgClasses="{'text-primary stroke-current': currentView === 'map'}"/>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    initView: String,
    buttons: Array
  },
  data () {
    return {
      currentView: 'list',
      path: this.$route.path
    }
  },
  methods: {
    update (type) {
      this.$emit(type)
      this.currentView = type
    }
  },
  created () {
    if (this.initView !== undefined) this.currentView = this.initView
  }
}
</script>
